import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=30968f28&scoped=true"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"
import style0 from "./OrderForm.vue?vue&type=style&index=0&id=30968f28&prod&lang=scss"
import style1 from "./OrderForm.vue?vue&type=style&index=1&id=30968f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30968f28",
  null
  
)

export default component.exports